import { InjectionToken } from '@angular/core';
import { EnvironmentConfig } from '@shared/interfaces/environment-config';

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>('EnvironmentConfig');
